import React, { useId } from "react";
import { useIntl } from "react-intl";
import { LocaleIntlKeys, LocaleType, LocaleTypes } from "@/model";
import { isValidTitle } from "@/util/helper/settingHelper";
import { DropdownGroup, DropdownButton, DropdownItems, DropdownItem, Textarea, TextInput } from "@/component/input";


interface ScenarioBaseInputChangeProps {
    name?: string;
    description?: string;
    locale?: LocaleType;
}

interface ScenarioBaseInputGroupProps extends ScenarioBaseInputChangeProps {
    onChange: (scenario: ScenarioBaseInputChangeProps) => void;
}

const ScenarioBaseInputGroup: React.FC<ScenarioBaseInputGroupProps> = (props) => {
    const { name, description, locale: scenarioLocale = "ko", onChange } = props;

    const intl = useIntl();
    const nameId = useId();
    const descId = useId();
    const localeId = useId();

    return (
        <fieldset className="scenario-setting-card-input-group">
            <legend className="sr-only">
                {intl.formatMessage({ id: "b0014" })}
            </legend>
            <div className="flex flex-col gap-1.5">
                <label htmlFor={nameId}
                       className="field-label"
                >
                    {intl.formatMessage({ id: "b0050" })}
                </label>
                <TextInput id={nameId}
                           required
                           value={name ?? ""}
                           invalid={!isValidTitle(name ?? "").isValid}
                           placeholder={intl.formatMessage({ id: "i10012" })}
                           onChange={e => onChange({ name: e.target.value })}
                />
            </div>

            <div className="flex flex-col gap-1.5">
                <label htmlFor={descId}
                       className="field-label"
                >
                    {intl.formatMessage({ id: "i10013" })}
                </label>
                <Textarea id={descId}
                          rows={3}
                          value={description ?? ""}
                          placeholder={intl.formatMessage({ id: "i10014" })}
                          onChange={v => onChange({ description: v })}
                />
            </div>

            <div className="flex flex-col gap-1.5">
                <div id={localeId}
                     className="field-label"
                >
                    {intl.formatMessage({ id: "b0025" })}
                </div>

                <DropdownGroup aria-labelledby={localeId}>{({ open, close }) => (<>
                    <DropdownButton open={open} close={close} isSelected={!!scenarioLocale}>
                        {intl.formatMessage({ id: LocaleIntlKeys[scenarioLocale!] ?? "i10015" })}
                    </DropdownButton>
                    <DropdownItems>
                        {LocaleTypes.map((locale, index) => (
                            <DropdownItem key={locale}
                                          isOdd={index % 2 === 1}
                                          onClick={() => onChange({ locale })}
                            >
                                {intl.formatMessage({ id: LocaleIntlKeys[locale] })}
                            </DropdownItem>
                        ))}
                    </DropdownItems>
                </>)}</DropdownGroup>
            </div>
        </fieldset>
    );
};

export default ScenarioBaseInputGroup;
